import React, { useState, useEffect } from "react";
import { Badge } from "./ui/badge";
import { Crown, Zap, Clock, Star, TrendingUp } from "lucide-react";

export const PricingBanner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const pricingInfo = [
    {
      title: "⚡ Exclusif - Résolutions Illimitées",
      subtitle: "Tous niveaux - 24h d'accès",
      highlight: "0,99€",
      details: "Résolutions texte illimitées. Upload fichier: 0,99€/crédit ⚡",
      icon: <Zap className="w-4 h-4" />,
      gradient: "from-purple-400 to-purple-600"
    },
    {
      title: "👑 The One - 70 Crédits Éclair",
      subtitle: "7 jours - Lycée & Plus",
      highlight: "3,99€",
      details: "70 crédits éclair (10/jour) + résolutions illimitées. Uploads inclus !",
      icon: <Crown className="w-4 h-4" />,
      gradient: "from-orange-400 to-orange-600"
    },
    {
      title: "💎 Premium Lycée - IA Standard",
      subtitle: "30 jours - Réponses adaptées lycée",
      highlight: "7,99€",
      details: "10 crédits éclair/jour auto-rechargés + IA GPT 6 Luna & Claude Sonnet",
      icon: <Star className="w-4 h-4" />,
      gradient: "from-blue-400 to-blue-600"
    },
    {
      title: "🎓 Premium Universitaire - IA EXPERT",
      subtitle: "30 jours - Recalcul multiple",
      highlight: "11,99€",
      details: "10 crédits/jour + IA Claude Opus avec vérification approfondie et recalcul",
      icon: <TrendingUp className="w-4 h-4" />,
      gradient: "from-pink-400 to-pink-600"
    },
    {
      title: "🚀 3 Crédits OFFERTS",
      subtitle: "Pour tous les nouveaux utilisateurs",
      highlight: "GRATUIT",
      details: "Testez toutes les fonctionnalités dès maintenant !",
      icon: <Clock className="w-4 h-4" />,
      gradient: "from-green-400 to-green-600"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % pricingInfo.length);
    }, 4000); // Change toutes les 4 secondes

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full overflow-hidden bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 border border-green-500/20 rounded-lg mb-6">
      {/* Effets de fond animés */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-1/4 w-2 h-2 bg-green-400 rounded-full animate-ping"></div>
        <div className="absolute top-1/2 right-1/4 w-1 h-1 bg-green-300 rounded-full animate-pulse delay-1000"></div>
        <div className="absolute bottom-1/4 left-1/3 w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse delay-2000"></div>
      </div>

      {/* Conteneur du carrousel */}
      <div 
        className="flex transition-transform duration-1000 ease-in-out"
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {pricingInfo.map((item, index) => (
          <div
            key={index}
            className="w-full flex-shrink-0 px-6 py-4 flex items-center justify-between"
          >
            <div className="flex items-center space-x-4">
              <div className={`p-3 rounded-full bg-gradient-to-r ${item.gradient} shadow-lg`}>
                {item.icon}
              </div>
              
              <div>
                <h3 className="text-lg font-bold text-green-400 mb-1">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-300">
                  {item.subtitle}
                </p>
              </div>
            </div>

            <div className="text-right">
              <Badge variant="secondary" className="mb-2 text-lg font-bold bg-green-500/20 text-green-400 border-green-500/30">
                {item.highlight}
              </Badge>
              <p className="text-xs text-gray-400 max-w-xs">
                {item.details}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Indicateurs de progression */}
      <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {pricingInfo.map((_, index) => (
          <button
            key={index}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              index === currentSlide
                ? 'bg-green-400 w-6'
                : 'bg-gray-600 hover:bg-gray-500'
            }`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>

      {/* Bordure animée */}
      <div className="absolute inset-0 rounded-lg border-2 border-transparent bg-gradient-to-r from-green-500/50 via-transparent to-green-500/50 animate-pulse"></div>
    </div>
  );
};